import SelectOptions from '../menuItemComponents/SelectOptions.vue';
import { getEditor, isEnabled } from '../composables/editorsMap';
import { spacingOptions, getCleanClass } from '../composables/utils';
import { ChevronsUpDown } from 'lucide-vue-next';
export const getSpacingOptions = (id: string) => {
  const editor = getEditor(id)?.value;

  return {
    disabled: !isEnabled(id, 'line_height'),
    icon: ChevronsUpDown,
    title: 'מרווח בין שורות ופיסקאות',
    type: 'select',
    component: SelectOptions,
    props: {
      type: 'lineHeight',
      options: spacingOptions,
      action: option => {
        const { $from } = editor?.state?.selection ?? null;
        const node = $from.node();
        if (option.type == 'line') {
          getEditor(id)
            .value.chain()
            .focus()
            .setLineHeight(option.attributes)

            .run();
        } else {
          getEditor(id)
            .value.chain()
            .focus()
            .updateAttributes(node.type.name, {
              ...node.attrs,
              class: getCleanClass(node, option),
            })
            .run();
        }
      },
      isActive: option => {
        const { $from } = editor?.state.selection ?? null;
        const node = $from.node();
        return editor?.isActive(node.type.name, {
          class: getCleanClass(node, option),
        });
      },
    },
  };
};
